"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PurePasswordReset = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _EmailInput = _interopRequireDefault(require("../EmailInput"));
var _Button = _interopRequireDefault(require("../Button"));
var _Header = _interopRequireDefault(require("../Header"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _resetPassword = _interopRequireDefault(require("../../api/Auth/resetPassword"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _appConfigHelper = require("../../util/appConfigHelper");
var _PasswordResetStyled = require("./PasswordResetStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class PasswordReset extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "onSubmit", async e => {
      e.preventDefault();
      const publisherId = (0, _appConfigHelper.getData)('CLEENG_PUBLISHER_ID');
      const {
        value
      } = this.state;
      const {
        onSuccess,
        t
      } = this.props;
      if (this.validateFields()) {
        this.setState({
          processing: true
        });
        const response = await (0, _resetPassword.default)(value, publisherId);
        if (response.errors.length) {
          if (response.status === 429) {
            this.setState({
              overloaded: true,
              processing: false,
              message: 'Server overloaded. Please try again later.'
            });
            setTimeout(() => {
              this.setState({
                overloaded: false,
                message: ''
              });
            }, 10 * 1000);
          } else {
            this.setState({
              processing: false,
              message: t(response.errors[0])
            });
          }
        } else {
          (0, _appConfigHelper.setData)('CLEENG_CUSTOMER_EMAIL', value);
          onSuccess(value);
        }
      }
      return true;
    });
    this.state = {
      value: '',
      message: '',
      processing: false,
      overloaded: false
    };
  }
  validateFields() {
    const {
      value
    } = this.state;
    const {
      t
    } = this.props;
    const errorFields = {
      email: EMAIL_REGEX.test(value) ? '' : t('This address does not seem to have a normal email format.')
    };
    this.setState({
      message: errorFields.email
    });
    return !Object.keys(errorFields).find(key => errorFields[key] !== '');
  }
  render() {
    const {
      value,
      message,
      processing,
      overloaded
    } = this.state;
    const {
      t
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PasswordResetStyled.PasswordResetWrapperStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PasswordResetStyled.PasswordResetPageStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetStyled.StyledTitle, {
          children: t('Forgot your password?')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetStyled.StyledMessage, {
          children: t('Just enter your email address below and we will send you a link to reset your password')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PasswordResetStyled.FormStyled, {
          onSubmit: this.onSubmit,
          noValidate: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailInput.default, {
            label: t('Email'),
            error: message,
            value: value,
            onChange: v => this.setState({
              value: v
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            type: "submit",
            theme: "confirm",
            size: "big",
            disabled: processing || overloaded,
            children: processing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              buttonLoader: true,
              color: "#ffffff"
            }) : t('Reset Password')
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
    });
  }
}
exports.PurePasswordReset = PasswordReset;
PasswordReset.propTypes = {
  onSuccess: _propTypes.default.func.isRequired,
  urlProps: _propTypes.default.shape({
    location: _propTypes.default.shape({
      search: _propTypes.default.string,
      state: _propTypes.default.shape({
        fromMyAccount: _propTypes.default.bool
      })
    })
  }),
  t: _propTypes.default.func
};
PasswordReset.defaultProps = {
  urlProps: {},
  t: k => k
};
var _default = exports.default = (0, _reactI18next.withTranslation)()(PasswordReset);